// components/TroubleshootingSection.tsx
import React from "react";
import { FormattedMessage } from "react-intl";

interface TroubleshootingSectionProps {
  questionId: string;
  answers: string[];
}

export const TroubleshootingSection: React.FC<TroubleshootingSectionProps> = ({
  questionId,
  answers,
}) => {
  return (
    <div>
      <p className="font-bold mt-6 text-base">
        <FormattedMessage id={questionId} />
      </p>
      <ul className="list-disc pl-[1.5em] mt-4 text-gray666 dark:text-white60">
        {answers.map((answerId, index) => (
          <li key={index} className="mb-2">
            <FormattedMessage id={answerId} />
          </li>
        ))}
      </ul>
    </div>
  );
};
